import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { FormGroup, FormFeedback } from "reactstrap";
import Label from "../base/Label";
import NumberFormat from "react-number-format";

class Phone extends React.Component {
  validate(value) {
    const { label, placeholder, required, error } = this.props;

    let errorMessage;
    const inputLabel = label || placeholder;
    const errorMessageLabel = error;

    if ((!value || !value.trim()) && required) {
      errorMessage = errorMessageLabel
        ? `${errorMessageLabel}`
        : `${inputLabel} is required`;
    }

    // To validate the phone number
    if (value && value.replace(/[^0-9]/g, "").length < 10) {
      errorMessage = "Invalid phone number";
    }

    return errorMessage;
  }
  renderInput({ field, form: { touched, errors, setFieldValue } }) {
    const {
      name,
      id,
      label,
      placeholder,
      error,
      onKeyDown,
      required,
      disabled,
      onChange
    } = this.props;

    let errorMessage = touched[name] && errors[name] ? errors[name] : null;
    if (error) {
      errorMessage = error;
    }
    const inputId = id || name;

    return (
      <FormGroup
        style={{ position: "relative" }}
        className={(!!errorMessage && "is-invalid") || ""}
      >
        {label && (
          <Label id={inputId} required={required}>
            {label}
          </Label>
        )}
        <NumberFormat
          format="(###) ###-####"
          mask="_"
          defaultValue={field.value}
          value={field.value}
          id={inputId}
          {...field}
          placeholder={placeholder || label}
          className={`form-control ${errorMessage ? "is-invalid" : ""}`}
          style={{
            background: "#F3F3F4",
            border: "none",
            borderRadius: "5px",
            fontSize: "14px",
            height: "40px"
          }}
          onChange={e => {
            onChange && onChange(e);
            setFieldValue(name, e.target.value);
          }}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />

        {errorMessage && (
          <FormFeedback style={{ position: "absolute", marginTop: 1 }}>
            {errorMessage}
          </FormFeedback>
        )}
      </FormGroup>
    );
  }

  render() {
    const { name, readOnly, phone, className } = this.props;

    return (
      <>
        {readOnly ? (
          <div className={className}>
            <Label>{phone}</Label>
          </div>
        ) : (
          <>
            <Field
              validate={this.validate.bind(this)}
              name={name}
              render={this.renderInput.bind(this)}
            />
          </>
        )}
      </>
    );
  }
}

Phone.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  onKeyDown: PropTypes.func
};

export default Phone;
